import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTitleListOfferProvidersQueryVariables = Types.Exact<{
	nodeId: Types.Scalars['ID']['input'];
	country: Types.Scalars['Country']['input'];
	first: Types.Scalars['Int']['input'];
	filter?: Types.InputMaybe<Types.TitleFilter>;
	offersFilter: Types.OfferFilter;
}>;

export type GetTitleListOfferProvidersQuery = {
	__typename?: 'Query';
	node?:
		| { __typename?: 'Article'; id: string }
		| { __typename?: 'Author'; id: string }
		| { __typename?: 'Bundle'; id: string }
		| { __typename?: 'Device'; id: string }
		| { __typename?: 'Episode'; id: string }
		| {
				__typename?: 'GenericTitleList';
				id: string;
				titles: {
					__typename?: 'GenericTitleListConnection';
					totalCount: number;
					edges?: Array<{
						__typename?: 'GenericTitleListEdge';
						node:
							| {
									__typename?: 'Movie';
									id: string;
									flatrate: Array<{
										__typename?: 'Offer';
										id: string;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
										};
									}>;
							  }
							| {
									__typename?: 'Show';
									id: string;
									flatrate: Array<{
										__typename?: 'Offer';
										id: string;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											clearName: string;
										};
									}>;
							  };
					}> | null;
				};
		  }
		| { __typename?: 'Genre'; id: string }
		| { __typename?: 'Movie'; id: string }
		| { __typename?: 'MultiStepSportEvent'; id: string }
		| { __typename?: 'Offer'; id: string }
		| { __typename?: 'Package'; id: string }
		| { __typename?: 'Page'; id: string }
		| { __typename?: 'Person'; id: string }
		| { __typename?: 'Season'; id: string }
		| { __typename?: 'Show'; id: string }
		| { __typename?: 'SingleStepSportEvent'; id: string }
		| { __typename?: 'SportCompetitionV2'; id: string }
		| { __typename?: 'SportCompetitorV2'; id: string }
		| { __typename?: 'Url'; id: string }
		| null;
};

export type TitleListOfferProviderFragment = {
	__typename?: 'GenericTitleListEdge';
	node:
		| {
				__typename?: 'Movie';
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					package: { __typename?: 'Package'; id: string; packageId: number; clearName: string };
				}>;
		  }
		| {
				__typename?: 'Show';
				id: string;
				flatrate: Array<{
					__typename?: 'Offer';
					id: string;
					package: { __typename?: 'Package'; id: string; packageId: number; clearName: string };
				}>;
		  };
};

export const TitleListOfferProviderFragmentDoc = gql`
	fragment TitleListOfferProvider on GenericTitleListEdge {
		node {
			id
			... on MovieOrShow {
				flatrate: offers(country: $country, platform: WEB, filter: $offersFilter) {
					id
					package {
						id
						packageId
						clearName
					}
				}
			}
		}
	}
`;
export const GetTitleListOfferProvidersDocument = gql`
	query GetTitleListOfferProviders(
		$nodeId: ID!
		$country: Country!
		$first: Int!
		$filter: TitleFilter
		$offersFilter: OfferFilter!
	) {
		node(id: $nodeId) {
			id
			... on GenericTitleList {
				titles(country: $country, first: $first, filter: $filter) {
					totalCount
					edges {
						...TitleListOfferProvider
					}
				}
			}
		}
	}
	${TitleListOfferProviderFragmentDoc}
`;
